<!-- Backdrop -->
@if (isOpen) {
  <div class="backdrop" (click)="closePanel()"></div>
}

<!-- Slide-in Panel -->
<div class="panel" [class.open]="isOpen">
  <div class="sticky-container">
    <div class="panel-header">
      <h3 class="panel-title">{{ title }}</h3>
      <div class="header-actions">
        @if (!showAddForm && enableAddComment) {
          <button class="add-cta" (click)="showAddForm = !showAddForm">
            <img src="assets/images/add-message.svg" alt="Add Message" />
          </button>
        }
        <button class="close-btn" (click)="closePanel()">✕</button>
      </div>
    </div>
    @if (groupMembersList.length) {
      <div
        class="add-form"
        [class.active]="showAddForm"
        [class.overflow]="dropdownOpen"
      >
        @if (showAddForm && enableAddComment) {
          <p class="form-title">New Message</p>
          <div class="form-send-to">
            <div class="form-send-container">
              <app-custom-dropdown
                class="to-dropdown"
                [(ngModel)]="selectedMembers"
                [multiselect]="true"
                multiSelectedLabel="Dealers selected"
                multiselectLabel="Select Dealers"
                (selectionChange)="onDealersSelected($event)"
                [options]="sendToMembers"
                (optionsOpen)="onDropdownToggle($event)"
                trackBy="display"
                label="Send to"
              />
            </div>
          </div>
          <div class="subject">
            <p class="subject-type">{{ type }}</p>
            <p class="subject-text">{{ subject }}</p>
          </div>
          <textarea
            class="comment-input"
            name="comment"
            (keyup)="errorMessage = ''"
            [(ngModel)]="newComment"
            placeholder="Write your message here..."
          ></textarea>
          <p class="error">{{ errorMessage }}</p>
          <div class="form-actions">
            <button class="action-cta cancel" (click)="showAddForm = false">
              Cancel
            </button>
            <button class="action-cta submit" (click)="submitComment()">
              Send
            </button>
          </div>
        }
      </div>
    }
  </div>
  <div class="panel-content">
    @if (filteredMessages.length === 0) {
      <p class="no-messages">No messages</p>
    }
    @for (message of filteredMessages; track message.commentId) {
      <app-single-comment
        [message]="message"
        [allDealers]="groupMembersList"
        [editEnable]="authUser?.email === message.emailAddress"
        [showType]="type === null"
        (deleteMessage)="onDeleteMessage($event)"
      />
    }
  </div>
</div>
